import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Stack, Button, Box, CircularProgress} from 'views/components';

import {Translate} from 'views/module';

import MessageFeedBox from './messages/MessageFeedBox';
import LogFeedBox from './logs/LogFeedBox';

{/* List of ClientLead messages and Logs associated with the ClientLead */}
const CorrespondanceFeed = (props) => {
  // Comments to display on clientLead

  const {
    clientLeadRn,

    // props for MessageFeedBox
    clientLeadMessages: messages,
    clientLeadLogs,

    clientLeadMessagesLoading,
    clientLeadMessagesLastEvaluatedKey,

    clientLeadLogsLastEvaluatedKey,
    clientLeadLogsLoading,

    sortDir,
    corType,
    clientLeadBackend,
  } = props;

  const loadMoreMessages = () => {
    if (clientLeadMessagesLoading && !clientLeadMessagesLoading) {
      clientLeadBackend.load.loadMessages(clientLeadRn, clientLeadMessagesLoading);
    }
    if (clientLeadLogsLastEvaluatedKey && !clientLeadLogsLoading) {
      clientLeadBackend.load.loadLogs(clientLeadRn, clientLeadLogsLastEvaluatedKey);
    }
  };

  const messagesToDisplayCaluclator = React.useCallback(() => {
    const messagesFilter = Object.values(messages)
        .filter((message) => {
          return corType[message.messageType];
        });

    let oldestMessage = null;
    if (clientLeadMessagesLastEvaluatedKey) {
      oldestMessage = Object.values(messages)
          .reduce((oldest, item) => {
            return new Date(item.createdAt) < new Date(oldest.createdAt) ? item : oldest;
          });
    }

    const logsFilter = Object.values(clientLeadLogs)
        .filter((log) => {
          if (corType['LOGS']) {
            // limit logs shows to the oldest message
            if (oldestMessage && new Date(oldestMessage.createdAt) > new Date(log.createdAt) ) {
              return false;
            }

            return true;
          }
        });

    const messagesAndlogs = [
      ...(messagesFilter.map((e) => {
        return {...e, type: 'MESSAGE'};
      })),
      ...(logsFilter.map((e) => {
        return {...e, type: 'LOGS'};
      })),
    ];

    const sortedMessages = messagesAndlogs.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);

      if (sortDir === 'DESC') {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
    });

    return sortedMessages;
  }, [messages, clientLeadLogs, sortDir, corType]);

  const messagesToDisplay = messagesToDisplayCaluclator();

  const moreMessages = clientLeadMessagesLoading || clientLeadLogsLoading;
  const showLoadMoreButton =
    (clientLeadMessagesLastEvaluatedKey && !clientLeadMessagesLoading) ||
    (clientLeadLogsLastEvaluatedKey && !clientLeadLogsLoading);

  return (
    <Grid container>
      <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 1 : 2}}>
        <Stack
          sx={{
            pt: 1,
            pb: 2,
          }}
        >
          {
            messagesToDisplay.map((message, index) => {
              if (message.type === 'MESSAGE') {
                return (
                  <Box
                    key={message.messageRn}
                  >
                    <MessageFeedBox
                      message={message}
                      clientLeadBackend={clientLeadBackend}
                    />
                  </Box>
                );
              } else if (message.type === 'LOGS') {
                return (
                  <Box
                    key={message.clientLeadLogRn}
                  >
                    <LogFeedBox
                      log={message}
                      clientLeadBackend={clientLeadBackend}
                    />
                  </Box>
                );
              }
              return null;
            })
          }
        </Stack>
      </Grid>
      {
        moreMessages &&
          <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
            <CircularProgress/>
          </Grid>
      }
      {
        showLoadMoreButton &&
        <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            color={'primary'}
            onClick={loadMoreMessages}
          >
            <Translate expression={'clientLead.ClientLeadDetail.Correspondance.Messages.LoadMore'} />
          </Button>
        </Grid>
      }
    </Grid>
  );
};
CorrespondanceFeed.propTypes = {
  clientLeadRn: PropTypes.string.isRequired,

  // props for MessageFeedBox
  clientLeadMessages: PropTypes.object.isRequired,
  clientLeadLogs: PropTypes.object.isRequired,

  clientLeadMessagesLoading: PropTypes.bool.isRequired,
  clientLeadMessagesLastEvaluatedKey: PropTypes.string,

  clientLeadLogsLoading: PropTypes.bool.isRequired,
  clientLeadLogsLastEvaluatedKey: PropTypes.string,

  sortDir: PropTypes.string.isRequired,
  corType: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
    LOGS: PropTypes.bool.isRequired,
  }).isRequired,

  clientLeadBackend: PropTypes.object.isRequired,

};

export default React.memo(CorrespondanceFeed);
